"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CheckableInput = _interopRequireDefault(require("../CheckboxInput/CheckableInput"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Radio input](https://docs.vanillaframework.io/base/forms#radio-button).
 *
 * Use radio buttons to select one of the given set of options.
 */
const RadioInput = _ref => {
  let {
    label,
    ...radioProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_CheckableInput.default, _extends({
    inputType: "radio",
    label: label
  }, radioProps));
};
var _default = exports.default = RadioInput;